import React, { useEffect, useState } from "react";
import CloseIcon from "@material-ui/icons/Close";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  makeStyles,
  Paper,
  Chip,
  Dialog,
  Typography,
  CircularProgress,
  Select,
  MenuItem,
  IconButton,
  Box,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import ClearIcon from "@material-ui/icons/Clear";
import {
  dateFormated,
  presentFormatedData,
} from "../../functionalComponents/dataFormatFunctions";
import { convertToLocaleDateTime } from "../../functionalComponents/FormatDateTimeToLocale";
import EditSponsorPOColumns from "../POColumns/EditSponsorPOColumns";
import EditCDMOPOColumns from "../POColumns/EditCDMOPOColumns";
import EditSAPPOColumns from "../POColumns/EditSAPPOColumns";
import EditPlannedMfgStartDate from "../POColumns/EditPlannedMfgStartDate";
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";
// import { useDispatch } from "react-redux";
// import { fetchSLFromPODashboard } from "../../../../containers/actions/common/purchaseOrderAction";

const useStyles = makeStyles(() => ({
  tableContainer: {
    maxHeight: 400, // Scrollable height
    overflowX: "auto",
  },
  headerCell: {
    backgroundColor: "#eee",
    fontWeight: "bold",
    // textAlign: "center",
    whiteSpace: "nowrap",
    height: "28px",
    padding: "10px",
  },
  groupedHeader: {
    backgroundColor: "#eee",
    fontWeight: "bold",
    textAlign: "center",
    whiteSpace: "nowrap",
    height: "28px",
    //   position: "sticky",
    padding: "10px",
    //   top: 0,
    //     zIndex: 3,
    border: "none",
    paddingBottom: "0px",
  },
}));

const PONegotiationTable = ({ data, handleRefresh, featuresAccess,showPencilIcon}) => {
  const classes = useStyles();
  // const dispatch = useDispatch();
  // const [poData, setPoData] = useState({});
  const [tableLoading, setTableLoading] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  // BCM-972: the Planned MFG Start Date "request edit access" confirmation,
  // raised inside EditPlannedMfgStartDate's tooltip but shown here, below the
  // table — same placement BCM-891 uses for the Planned Allocated Qty. one.
  const [accessRequest, setAccessRequest] = useState(null); // {severity, text}
  
  // Reason code state
  const [isEditingReasonCode, setIsEditingReasonCode] = useState(false);
  const [selectedReasonCode, setSelectedReasonCode] = useState("");
  const [originalReasonCode, setOriginalReasonCode] = useState("");
  const [reasonCodeChanged, setReasonCodeChanged] = useState(false);
  const [reasonCodes, setReasonCodes] = useState([]);
  const [reasonCodesLoading, setReasonCodesLoading] = useState(false);
  const [reasonCodesFetched, setReasonCodesFetched] = useState(false);
  const [reasonCodeSaving, setReasonCodeSaving] = useState(false);

  // Initialize reason code from data
  useEffect(() => {
    const rawReasonCode = data?.scheduleLineDetails?.poLevelReasonCode;
    // Convert null, undefined, empty string, or string "null"/"none" to ""
    const currentReasonCode = (!rawReasonCode || rawReasonCode === "none" || rawReasonCode === "null" || rawReasonCode === "null - " || rawReasonCode.startsWith("null -")) ? "" : rawReasonCode;
    setSelectedReasonCode(currentReasonCode);
    setOriginalReasonCode(currentReasonCode);
    setReasonCodeChanged(false);
    setIsEditingReasonCode(false);
  }, [data]);
  
  //console.log("featuresAccessInTimeAndQty", featuresAccess);
  //console.log("showPencilIcon value in Ponegationtable",showPencilIcon)

  // useEffect(() => {
  //   let requestObj = {
  //     schrockenSAID: data?.scheduleLineDetails?.schrockenSAID,
  //     fgMaterialCode: null,
  //     scheduleLineStatusID: 0,
  //     pageNumber: 1,
  //     pageSize: 5,
  //   };
  //   setTableLoading(true);

  // useEffect(() => {
  //   if (data) {
  //     const Body = {
  //       schrockenSLID: data?.scheduleLineDetails?.schrockenSLID,
  //     };
  //     setLoading(true);

  //     axios
  //       .post(
  //         `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/checkedNewProposal`,
  //         Body // ✅ Comma added here
  //       )
  //       .then((res) => {
  //         if (res.data.status) {
  //           console.log("Proposal checked successfully");
  //         }
  //       })
  //       .catch((err) => {
  //         console.error("API Error:", err);
  //       })
  //       .finally(() => {
  //         setLoading(false);
  //       });
  //   }
  // }, [data]);

  //   axios
  //     .post(
  //       `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOLineItems`,
  //       requestObj
  //     )
  //     .then((res) => {
  //       if (res.data.status) {
  //         const fetchedData = res.data.data.SLDetails.map((item) => ({
  //           ...item,
  //         }));
  //         if (Array.isArray(fetchedData) && fetchedData.length > 0) {
  //           setPoData({
  //             ...res.data.data,
  //             SLDetails: fetchedData[0],
  //           });
  //         } else {
  //           setPoData({});
  //           setError(true);
  //         }

  //         setTableLoading(false);
  //       } else {
  //         setError(true); // If API response is not successful
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setError(true);
  //     })
  //     .finally(() => {
  //       setTableLoading(false);
  //     });
  // }, [data]);

  // Fetch reason codes from API
  const fetchReasonCodes = async () => {
    try {
      const requestObject = {
        searchField: "all",
        searchValue: "",
        reasonCodeGroupType: "all",
        reasonCodeType: "all",
        status: "all",
        collaboratorTypeID: "all",
      };
      const response = await axios.post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchReasonCodesDirect`,
        requestObject
      );
      if (response.data.status) {
        return response.data?.data?.reasonCodeList || [];
      }
      return [];
    } catch (err) {
      console.error("Error fetching reason codes:", err);
      return [];
    }
  };

  // Save reason code to PO
  const saveReasonCodeToPO = async (schrockenSLID, reasonCode) => {
    try {
      const requestBody = {
        vendorMosymphonyID: data?.scheduleLineDetails?.vendorMosymphonyID,
        poLevelReasonCode: reasonCode || "none",
        schrockenSLID:data?.scheduleLineDetails?.schrockenSLID,
      };
      const response = await axios.post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateSLForPOMgmt`,
        requestBody
      );
      if (response.data.status) {
        setOriginalReasonCode(reasonCode);
        return true;
      }
      throw new Error("Failed to save reason code");
    } catch (err) {
      console.error("Error saving reason code:", err);
      throw err;
    }
  };

  // Refresh SL data and trigger purchase orders refresh with page reset but maintain filters
  // const refreshSLData = async () => {
  //   const schrockenSLID = data?.scheduleLineDetails?.schrockenSLID;
    
  //   try {
  //     // Refresh the main purchase orders data and reset to page 1 
  //     // since the updated record will be on page 1 after reason code update
  //     // Using 'reasonCodeUpdated' as a custom type to reset page but maintain filters
  //     if (typeof handleRefresh === "function") {
  //       handleRefresh('reasonCodeUpdated');
  //     }
      
  //     // Then refresh the specific SL data
  //     if (schrockenSLID && dispatch) {
  //       await dispatch(fetchSLFromPODashboard(schrockenSLID));
  //     }
  //   } catch (error) {
  //     console.error("Failed to refresh data:", error);
  //   }
  // };

  // Handle pencil icon click - fetch reason codes and enable editing
  const handleEditReasonCodeClick = async () => {
    setIsEditingReasonCode(true);
    if (!reasonCodesFetched) {
      setReasonCodesLoading(true);
      try {
        const codes = await fetchReasonCodes();
        setReasonCodes(codes);
        setReasonCodesFetched(true);
      } catch (err) {
        console.error("Error fetching reason codes:", err);
        setReasonCodes([]);
      } finally {
        setReasonCodesLoading(false);
      }
    }
  };

  // Handle dropdown open - fetch reason codes if not already fetched
  const handleDropdownOpen = async () => {
    if (!reasonCodesFetched) {
      setReasonCodesLoading(true);
      try {
        const codes = await fetchReasonCodes();
        setReasonCodes(codes);
        setReasonCodesFetched(true);
      } catch (err) {
        console.error("Error fetching reason codes:", err);
        setReasonCodes([]);
      } finally {
        setReasonCodesLoading(false);
      }
    }
  };

  // Handle clear reason code
  const handleClearReasonCode = () => {
    setSelectedReasonCode("");
    setReasonCodeChanged("" !== originalReasonCode);
  };

  // Handle cancel edit
  const handleCancelEdit = () => {
    setSelectedReasonCode(originalReasonCode);
    setReasonCodeChanged(false);
    setIsEditingReasonCode(false);
  };


  // Handle save reason code
  const handleSaveReasonCode = async () => {
    setReasonCodeSaving(true);
    try {
      await saveReasonCodeToPO(
        data?.scheduleLineDetails?.schrockenSLID,
        selectedReasonCode
      );
      setOriginalReasonCode(selectedReasonCode);
      setReasonCodeChanged(false);
      setIsEditingReasonCode(false);
      if (typeof handleRefresh === "function") handleRefresh();
      
      // Refresh only SL data instead of full table refresh
      // await refreshSLData();
    } catch (error) {
      console.error("Error saving reason code:", error);
      // You can add error handling here (snackbar, etc.)
    } finally {
      setReasonCodeSaving(false);
    }
  };
  const sl = data?.scheduleLineDetails || {};

  // BCM-791: the single source of truth for the rejection note — the API's
  // free-text rejectionNote has come back malformed/unreliable so it's never
  // read; instead the sentence is built from the individual structured
  // fields the backend DOES persist reliably: cmoRejectedSponsorProposal
  // (gate), cmoRejectedQuantity / cmoRejectedDate (the value(s) rejected —
  // a single reject action targets qty XOR date, but both are included if
  // both happen to carry a real value), sponsorProposalRejectedByCMOUser
  // (who rejected it — despite the name, this is the rejecting CMO user's
  // identifier, an email), and cmoRejectionDate (when).
  const cmoRejectionNoteText = (() => {
    if (!sl.cmoRejectedSponsorProposal) return "";
    const parts = [];
    if (sl.cmoRejectedQuantity != null && sl.cmoRejectedQuantity !== 0) {
      parts.push(`Qty of ${sl.cmoRejectedQuantity}`);
    }
    if (sl.cmoRejectedDate) {
      parts.push(`Date of ${dateFormated(sl.cmoRejectedDate, "DD-MMM-YYYY", "")}`);
    }
    if (parts.length === 0) return "";
    const rejectingUser = sl.sponsorProposalRejectedByCMOUser || "";
    // cmoRejectionDate is a UTC timestamp — convertToLocaleDateTime converts
    // it to the viewer's local timezone (moment() alone would not).
    const localTimestamp = sl.cmoRejectionDate
      ? convertToLocaleDateTime(sl.cmoRejectionDate)
      : "";
    const timestamp =
      localTimestamp && localTimestamp !== "Invalid date input"
        ? localTimestamp.toUpperCase()
        : "";
    return `BMS Proposed ${parts.join(" and ")} was rejected by CMO user ${rejectingUser}${
      timestamp ? ` on ${timestamp}` : ""
    }`;
  })();

  return (
    <React.Fragment>
      <TableContainer
        style={{
          marginTop: "1rem",
          minHeight: "auto",
          maxHeight: "400px",
          width: "90%",
        }}
        component={Paper}
        className={`${classes.tableContainer} default-table-styles`}
      >
        <Table className="default-table-styles">
          {/* Table Head */}
          <TableHead>
            {/* Main header row */}
            <TableRow>
              <TableCell
                align="left"
                className={classes.headerCell}
                rowSpan={2}
              >
                Date Of Creation
              </TableCell>
              {/* <TableCell className={classes.groupedHeader} colSpan={2}>
                Statistical values
              </TableCell> */}
              {/* BCM-1029: Original Qty. is now grouped with the new read-only
                  Original Stat Date field under a shared "Original Values" header. */}
              <TableCell
                align="right"
                className={classes.groupedHeader}
                colSpan={2}
              >
                Original Values
              </TableCell>
              {/* <TableCell className={classes.headerCell} rowSpan={2}>
                PO confirmation date
              </TableCell> */}
              <TableCell
                align="right"
                className={classes.groupedHeader}
                colSpan={2}
              >
                SAP PO Values
              </TableCell>
              <TableCell className={classes.groupedHeader} colSpan={2}>
                BMS Proposed Values
              </TableCell>
              <TableCell className={classes.groupedHeader} colSpan={2}>
                CMO Proposed Values
              </TableCell>
              <TableCell className={classes.headerCell} rowSpan={2}>
                UOM
              </TableCell>
              <TableCell className={classes.headerCell} rowSpan={2}>
              PO-level Reason Code / Description
              </TableCell>
              {/* BCM-972 (doc, "Display and Editing of the Planned MFG Start Date Field"):
                  last column of the Time and Qty. Details tab, after PO-level Reason Code / Description. */}
              <TableCell className={classes.headerCell} rowSpan={2}>
              Planned MFG Start Date
              </TableCell>
              {/* <TableCell className={classes.headerCell} rowSpan={2}>Statistical Date</TableCell> */}
            </TableRow>

            {/* Sub headers */}
            <TableRow>
              {/* <TableCell
                align='right'
                style={{ top: 38, paddingTop:'0px' }}
                className={classes.headerCell}
              >
                Qty
              </TableCell>
              <TableCell
                align='left'
                style={{ top: 38, paddingTop:'0px' }}
                className={classes.headerCell}
              >
                Date
              </TableCell> */}

              {/* BCM-1029: Original Values sub-headers — Qty. (existing requestedQuantity)
                  and the new read-only Stat Date (originalStatDate). */}
              <TableCell
                align="right"
                style={{ top: 38, paddingTop: "0px" }}
                className={classes.headerCell}
              >
                Qty.
              </TableCell>
              <TableCell
                align="left"
                style={{ top: 38, paddingTop: "0px" }}
                className={classes.headerCell}
              >
                Stat Date
              </TableCell>

              <TableCell
                align="right"
                style={{ top: 38, paddingTop: "0px",paddingLeft:"2rem" }}
                className={classes.headerCell}
              >
                Qty.
              </TableCell>
              <TableCell
                align="left"
                style={{ top: 38, paddingTop: "0px" }}
                className={classes.headerCell}
              >
                {/* Stat. date */}
                Statistical Date
              </TableCell>

              <TableCell
                align="right"
                style={{ top: 38, paddingTop: "0px",paddingLeft:"2.3rem" }}
                className={classes.headerCell}
              >
                Qty.
              </TableCell>
              <TableCell
                align="left"
                style={{ top: 38, paddingTop: "0px" }}
                className={classes.headerCell}
              >
                Date
              </TableCell>

              <TableCell
                align="right"
                style={{ top: 38, paddingTop: "0px" }}
                className={classes.headerCell}
              >
                Qty.
              </TableCell>
              <TableCell
                align="left"
                style={{ top: 38, paddingTop: "0px" }}
                className={classes.headerCell}
              >
                Date
              </TableCell>
            </TableRow>
          </TableHead>

          {/* Table Body */}
          {tableLoading ? (
            <TableBody>
              <TableRow>
                <TableCell colSpan={12}>
                  <div style={{ textAlign: "center" }}>
                    <CircularProgress color="primary" thickness={7} />
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          ) : error ? (
            <TableBody>
              <TableRow
                style={{
                  border: "2px solid rgb(255,0,0)",
                  backgroundColor: "rgb(255,240,240)",
                  Opacity: 1,
                  textAlign: "center",
                  padding: "0.8rem",
                  fontSize: "0.875rem",
                }}
              >
                <TableCell
                  style={{ padding: "10px" }}
                  colSpan={12}
                  align="center"
                >
                  Something went wrong. Please try again later.
                </TableCell>
              </TableRow>
            </TableBody>
          ) : (
            <TableBody>
              {Object.keys(data).length === 0 ? (
                <TableRow>
                  <TableCell colSpan={12} align="center">
                    No data available
                  </TableCell>
                </TableRow>
              ) : (
                <TableRow>
                  <TableCell
                    align="left"
                    style={{ whiteSpace: "nowrap", padding: "10px" }}
                  >
                    {/* <EditPoCreation data={data?.SADetails} /> */}
                    {dateFormated(
                      data?.scheduleLineDetails?.creationDate,
                      "DD-MMM-YYYY",
                      ""
                    )}
                  </TableCell>

                  {/* <TableCell
                    align='right'
                    style={{ whiteSpace: "nowrap", padding: "10px" }}
                  >
                    {presentFormatedData(data?.scheduleLineDetails?.requestedQuantity)}
                  </TableCell>

                  <TableCell
                    align='left'
                    style={{ whiteSpace: "nowrap", padding: "10px" }}
                  >
                    {dateFormated(
                      data?.scheduleLineDetails?.statisticalDate,
                      "DD-MMM-YYYY",
                      "NA"
                    )}
                  </TableCell> */}

                  <TableCell
                    align="right"
                    style={{ whiteSpace: "nowrap", padding: "10px" }}
                  >
                    {presentFormatedData(
                      data?.scheduleLineDetails?.requestedQuantity
                    )}
                  </TableCell>

                  {/* BCM-1029: read-only Original Stat Date — never edited after
                      the first sync, so no edit icon here (unlike SAP/BMS/CMO dates). */}
                  <TableCell
                    align="left"
                    style={{ whiteSpace: "nowrap", padding: "10px" }}
                  >
                    {dateFormated(
                      data?.scheduleLineDetails?.originalStatDate,
                      "DD-MMM-YYYY",
                      ""
                    )}
                  </TableCell>

                  {/* <TableCell
                    align='left'
                    style={{ whiteSpace: "nowrap", padding: "10px" }}
                  >
                    {dateFormated(
                      data?.scheduleLineDetails?.deliveryDate,
                      "DD-MMM-YYYY",
                      "NA"
                    )}
                  </TableCell> */}
                  <EditSAPPOColumns
                    row={data}
                    handleRefresh={handleRefresh}
                    featuresAccess={featuresAccess}
                    showPencilIcon={showPencilIcon}
                  />
                  <EditSponsorPOColumns
                    row={data}
                    handleRefresh={handleRefresh}
                    featuresAccess={featuresAccess}
                    showPencilIcon={showPencilIcon}
                  />
                  <EditCDMOPOColumns
                    row={data}
                    handleRefresh={handleRefresh}
                    featuresAccess={featuresAccess}
                    showPencilIcon={showPencilIcon}
                  />

                  <TableCell
                    align="left"
                    style={{ whiteSpace: "nowrap", padding: "10px" }}
                  >
                    {presentFormatedData(
                      data?.scheduleLineDetails?.targetQuantityUOM
                    )}
                  </TableCell>

                  <TableCell
                    align="left"
                    style={{ whiteSpace: "nowrap", padding: "10px" }}
                  >
                  {/* Reason Code Dropdown with Pencil/Save/Cancel Icons */}
                  <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                    {/* Reason Code Dropdown - Always visible */}
                    <Select
                      value={selectedReasonCode || ""}
                      onChange={(e) => {
                        setSelectedReasonCode(e.target.value);
                        setReasonCodeChanged(e.target.value !== originalReasonCode);
                      }}
                      onOpen={handleDropdownOpen}
                      displayEmpty
                      style={{ minWidth: 400, background: "#fff", flex: 1,border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "4px 8px" }}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 300,
                            zIndex: 2001,
                          },
                        },
                      }}
                      disabled={!isEditingReasonCode || reasonCodesLoading || reasonCodeSaving}
                      renderValue={(value) => {
                        // Check for null/empty/undefined values OR the string "null"/"none"/"null - "
                        if (value===null || value===undefined || value==='' || !value || value==="none" || value==="null" || value==="null - " || (typeof value === 'string' && value.startsWith("null -"))) {
                          return <em style={{ color: "#999", fontStyle: "normal" }}>Select from list</em>;
                        }
                        const code = reasonCodes.find((c) => c.reasonCode === value);
                        return code 
                          ? `${code.reasonCode} - ${code.description || code.reasonDescription || ""}`
                          : value;
                      }}
                    >
                      <MenuItem value="">
                      <em style={{ 
      color: "#999", 
      fontStyle: "normal",
      fontFamily: "Roboto, Arial, sans-serif",
      fontSize: "14px",
      fontWeight: 400
    }}>
      Select from list
    </em>
                      </MenuItem>
                      {reasonCodesLoading ? (
                        <MenuItem value="loading" disabled>
                          <em>Loading...</em>
                        </MenuItem>
                      ) : (
                        reasonCodes.map((code) => (
                          <MenuItem key={code.reasonCode} value={code.reasonCode}>
                            {code.reasonCode} - {code.description || code.reasonDescription || ""}
                          </MenuItem>
                        ))
                      )}
                    </Select>
                    {/* Icons - Conditional based on editing state */}
                    {!isEditingReasonCode ? (
                      /* Pencil Icon - Show when not editing */
                      // localStorage.collabType !== "CMO" &&
                      // featuresAccess?.editSponsorProposedValues &&
                      // showPencilIcon &&
                      // data?.scheduleLineDetails?.cmoToUsePOInterface === true 
                      localStorage.collabType !== "CMO" && showPencilIcon && featuresAccess?.editPOReasonCode && (
                        <IconButton 
                          aria-label="edit reason code"
                          size="small"
                          onClick={handleEditReasonCodeClick}
                          style={{ padding: 4, color: "#E78A00" }}
                        >
                          <EditIcon fontSize="large" />
                        </IconButton>
                      )
                    ) : (
                     
                     /* Save and Cancel Icons - Show when editing */
                     <div style={{ display: "flex", flexDirection: "column", gap: "1px" }}>
                     <IconButton
                       aria-label="cancel"
                       size="small"
                       onClick={handleCancelEdit}
                       disabled={reasonCodeSaving}
                       style={{ padding: 2, color: "#000000" }}
                     >
                       <ClearIcon fontSize="small" />
                     </IconButton>
                     <IconButton
                       aria-label="save reason code"
                       size="small"
                       onClick={handleSaveReasonCode}
                       disabled={reasonCodeSaving}
                       style={{ padding: 2, color: "#000000" }}
                     >
                       <SaveIcon fontSize="small" />
                     </IconButton>
                   </div>
                    )}
                  </div>

                  </TableCell>

                  {/* BCM-972 (doc, "Display and Editing of the Planned MFG Start Date Field"):
                      last column, editable only by CMO users of role Admin/CSP/Account Manager. */}
                  <TableCell
                    align="left"
                    style={{ whiteSpace: "nowrap", padding: "10px" }}
                  >
                    <EditPlannedMfgStartDate
                      row={data}
                      handleRefresh={handleRefresh}
                      featuresAccess={featuresAccess}
                      onAccessRequestResult={setAccessRequest}
                    />
                  </TableCell>

                </TableRow>
              )}
            </TableBody>
          )}
        </Table>
      </TableContainer>

      {/* BCM-972: confirmation banner for a Planned MFG Start Date access
          request raised from EditPlannedMfgStartDate's tooltip (or found
          already outstanding on load), shown below the table like BCM-891's
          for Planned Allocated Qty.. Dismissable, and it does not change the
          state of the edit button. */}
      {accessRequest && (
        <Box
          style={{
            marginTop: "8px",
            padding: "10px 14px",
            borderRadius: 4,
            width: "90%",
            display: "flex",
            alignItems: "flex-start",
            gap: 10,
            border: `1px solid ${accessRequest.severity === "success" ? "#a5d6a7" : "#ef9a9a"}`,
            backgroundColor: accessRequest.severity === "success" ? "#edf7ed" : "#fdecea",
          }}
        >
          {accessRequest.severity === "success" && (
            <Typography variant="body2" style={{ color: "#2e7d32", fontWeight: 700 }}>
              ✓
            </Typography>
          )}
          <Box style={{ flex: 1 }}>
            <Typography variant="body2" style={{ color: "#1c1c1e", fontSize: 14 }}>
              {accessRequest.boldLead && <strong>{accessRequest.boldLead}</strong>}
              {accessRequest.rest}
            </Typography>
            {accessRequest.secondary && (
              <Typography variant="body2" style={{ color: "#5f6368", fontSize: 13, marginTop: 2 }}>
                {accessRequest.secondary}
              </Typography>
            )}
          </Box>
          <IconButton size="small" onClick={() => setAccessRequest(null)} style={{ padding: 4 }}>
            <CloseIcon fontSize="small" style={{ color: "#5f6368" }} />
          </IconButton>
        </Box>
      )}

      {cmoRejectionNoteText && (
        <div
          style={{
            marginTop: "8px",
            padding: "10px 14px",
            border: "1px solid #ccc",
            backgroundColor: "#fafafa",
            width: "90%",
          }}
        >
          <Typography style={{fontWeight:480}} variant="body2">{cmoRejectionNoteText}</Typography>
        </div>
      )}
    </React.Fragment>
  );
};

export default PONegotiationTable;
